<template>
  <div>
    <b-card>
      <!--begin::Signin-->
      <div class="login-form login-signin">
        <div class="text-center mb-10 mb-lg-20">
          <h3 class="font-size-h1">بازیابی رمز عبور</h3>
          <p class="text-muted font-weight-semi-bold">
            شماره همراه خود را وارد کنید
          </p>
        </div>

        <!--begin::Form-->
        <b-form class="form" @submit.stop.prevent="onSubmit">
          <div
            role="alert"
            v-bind:class="{ show: errors.length }"
            class="alert fade alert-danger"
          >
            <div class="alert-text" v-for="(error, i) in errors" :key="i">
              {{ error }}
            </div>
          </div>
          <b-alert :show="success" variant="success"
            >کد تغییر رمز عبور برای شما ارسال گردید</b-alert
          >
          <b-form-group
            id="example-input-group-1"
            label="تلفن همراه"
            label-for="example-input-1"
          >
            <b-form-input
              id="example-input-1"
              name="example-input-1"
              v-model="$v.form.email.$model"
              :state="validateState('email')"
              aria-describedby="input-1-live-feedback"
              placeholder="تلفن همراه"
              mask="###########"
            ></b-form-input>

            <b-form-invalid-feedback id="input-1-live-feedback"
              >تلفن همراه را به صورت صحیح وارد کنید</b-form-invalid-feedback
            >
          </b-form-group>

          <b-form-group label="کد تایید">
            <b-row>
              <b-col cols="5">
                <b-form-input
                  v-model="form.captcha"
                  placeholder="کد تایید"
                ></b-form-input>
              </b-col>
              <b-col cols="5">
                <b-img
                  center
                  fluid
                  :src="captcha_img"
                  style="height: 38px"
                ></b-img>
              </b-col>
              <b-col>
                <b-button variant="warning" @click="resetCaptcha"
                  ><b-icon icon="arrow-clockwise"></b-icon
                ></b-button>
              </b-col>
            </b-row>
          </b-form-group>

          <!--begin::Action-->
          <div
            class="form-group d-flex flex-wrap justify-content-between align-items-center"
          >
            <button
              ref="kt_login_signin_submit"
              class="btn btn-success btn-block font-weight-bold px-9 py-4 my-3 font-size-3"
            >
              ارسال کد پیامکی
            </button>
          </div>
          <!--end::Action-->
          <!--begin::Action-->
          <div
            class="form-group d-flex flex-wrap justify-content-between align-items-center"
          >
            <router-link
              class="font-weight-bold font-size-3 ml-2"
              :to="{ name: 'login' }"
              >ورود</router-link
            >

            <router-link
              class="font-weight-bold font-size-3 ml-2"
              :to="{ name: 'register' }"
              >ثبت نام</router-link
            >
          </div>
          <!--end::Action-->
        </b-form>
        <!--end::Form-->
      </div>
      <!--end::Signin-->
    </b-card>
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-left: 3.5rem !important;
}
</style>

<script>
import VueRecaptcha from "vue-recaptcha";
import { mapState } from "vuex";
import { LOGIN, LOGOUT } from "@/core/services/store/auth.module";

import { validationMixin } from "vuelidate";
import { email, minLength, required } from "vuelidate/lib/validators";
import httpHelper from "../../helpers/httpHelper";
import sessionHelper from "../../helpers/sessionHelper";
const numbers = (value, vm) => !/[^0-9]/.test(value);
const mobile = (value, vm) => /^[\u06F0-\u06F9\s||z0-9]{11}$/.test(value);
const mustBeMobile = (value) =>
  value.startsWith("09") || value.startsWith("۰۹");
export default {
  mixins: [validationMixin],
  name: "forgetpass",
  components: {
    "vue-recaptcha": VueRecaptcha,
  },
  data() {
    return {
      // Remove this dummy login info
      form: {
        email: "",
        captcha: "",
      },
      captcha_img: "",
      success: false,
      errors: [],
    };
  },
  validations: {
    form: {
      email: {
        required,
        mustBeMobile,
        mobile,
      },
    },
  },
  methods: {
    resetCaptcha() {
      httpHelper.getData("cp").then((res) => {
        this.captcha_img = res.result.img;
        this.form.captcha = "";
        this.form.key = res.result.key;
      });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onVerify: function(response) {
      if (response) {
        this.form.robot = true;
        this.form.captcha = response;
      }
    },
    resetForm() {
      this.form = {
        email: null,
        password: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const email = this.$v.form.email.$model;
      this.errors = [];

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      var data = {
        email: email,
        captcha: this.form.captcha,
        key: this.form.key,
      };
      httpHelper
        .postData("users/resetpass", data)
        .then((res) => {
          this.resetCaptcha();
          if (res.success == false) {
            this.errors = [res.error];
          } else {
            this.success = true;
            //sessionHelper.setUser(res.result);
            this.$router.push({ name: "forget_step_2" });
          }
        })
        .finally(() => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    },
  },
  computed: {},
  mounted() {
    this.resetCaptcha();
  },
};
</script>
